var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "big" },
    [
      _c(
        "el-form",
        { attrs: { inline: true, "label-position": "top" } },
        [
          _c(
            "el-form-item",
            { attrs: { label: "渠道" } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "渠道" },
                  on: {
                    change: function () {
                      _vm.channelInt = _vm.searchOption(
                        _vm.channelList,
                        _vm.channel
                      )
                    },
                  },
                  model: {
                    value: _vm.channel,
                    callback: function ($$v) {
                      _vm.channel = $$v
                    },
                    expression: "channel",
                  },
                },
                _vm._l(_vm.channelList, function (item, index) {
                  return _c("el-option", { key: index, attrs: { value: item } })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "通道的id" } },
            [
              _c("el-input", {
                attrs: { placeholder: "通道的id" },
                model: {
                  value: _vm.ItemId,
                  callback: function ($$v) {
                    _vm.ItemId = $$v
                  },
                  expression: "ItemId",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                [_vm._v("查询")]
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.openAddChannelDialog },
                },
                [_vm._v("添加通道")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.ChannelItemList === null
        ? _c("el-card", [_vm._v("暂无此通道")])
        : _c(
            "div",
            _vm._l(_vm.ChannelItemList, function (item, idx) {
              return item.Channel !== ""
                ? _c(
                    "el-card",
                    { key: idx, staticClass: "my-card" },
                    [
                      _c(
                        "el-row",
                        _vm._l(item, function (item1, index1) {
                          return _c(
                            "el-col",
                            {
                              key: index1,
                              class: { spa: index1 >= 3 },
                              attrs: { span: 12, xs: 24, sm: 12 },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "grid-content" },
                                [
                                  _c("span", { staticClass: "label" }, [
                                    _vm._v(_vm._s(index1) + " "),
                                  ]),
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        content: _vm.displaySecret(
                                          index1,
                                          item1
                                        ),
                                        placement: "top",
                                      },
                                    },
                                    [
                                      _c("span", { staticClass: "value" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.displaySecret(index1, item1)
                                          )
                                        ),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          )
                        }),
                        1
                      ),
                      _c(
                        "el-button",
                        {
                          staticStyle: { float: "right", "z-index": "99" },
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.openUpdateChannelDialog(item)
                            },
                          },
                        },
                        [_vm._v("修改通道 ")]
                      ),
                    ],
                    1
                  )
                : _vm._e()
            }),
            1
          ),
      _c(
        "el-dialog",
        {
          attrs: { title: "修改通道", visible: _vm.updateChannelDialogVisible },
          on: {
            "update:visible": function ($event) {
              _vm.updateChannelDialogVisible = $event
            },
            close: _vm.closeAddChannelDialog,
          },
        },
        [
          _c(
            "el-form",
            { attrs: { inline: true, "label-position": "top" } },
            [
              _vm._l(_vm.channelDetails, function (item, idx) {
                return _c(
                  "el-form-item",
                  { key: item.label, attrs: { label: item.label } },
                  [
                    _c("el-input", {
                      attrs: {
                        disabled: idx === 0,
                        placeholder: _vm.secretPlaceholder(item.label),
                      },
                      model: {
                        value: item.value,
                        callback: function ($$v) {
                          _vm.$set(item, "value", $$v)
                        },
                        expression: "item.value",
                      },
                    }),
                    _vm.isSecretField(item.label)
                      ? _c("div", { staticClass: "secret-hint" }, [
                          _vm._v(_vm._s(_vm.secretHint(item))),
                        ])
                      : _vm._e(),
                  ],
                  1
                )
              }),
              _vm.interfaceStr
                ? _c(
                    "el-form-item",
                    { attrs: { label: "Name" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.channelDetail.Name,
                          callback: function ($$v) {
                            _vm.$set(_vm.channelDetail, "Name", $$v)
                          },
                          expression: "channelDetail.Name",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "通道类型" } },
                [
                  _c(
                    "el-select",
                    {
                      on: {
                        change: function () {
                          _vm.channelDetail.Type = _vm.searchOption(
                            _vm.channelTypeList,
                            _vm.channelType
                          )
                        },
                      },
                      model: {
                        value: _vm.channelType,
                        callback: function ($$v) {
                          _vm.channelType = $$v
                        },
                        expression: "channelType",
                      },
                    },
                    _vm._l(_vm.channelTypeList, function (item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { value: item },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "备注" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.channelDetail.ReMark,
                      callback: function ($$v) {
                        _vm.$set(_vm.channelDetail, "ReMark", $$v)
                      },
                      expression: "channelDetail.ReMark",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "状态" } },
                [
                  _c("el-switch", {
                    model: {
                      value: _vm.channelDetail.Status,
                      callback: function ($$v) {
                        _vm.$set(_vm.channelDetail, "Status", $$v)
                      },
                      expression: "channelDetail.Status",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "风控开关" } },
                [
                  _c("el-switch", {
                    model: {
                      value: _vm.channelDetail.RiskStatus,
                      callback: function ($$v) {
                        _vm.$set(_vm.channelDetail, "RiskStatus", $$v)
                      },
                      expression: "channelDetail.RiskStatus",
                    },
                  }),
                ],
                1
              ),
              _vm.channelDetail.RiskStatus
                ? _c("el-form-item", { attrs: { label: "风控通道Key" } }, [
                    _vm.editChannelRiskShow
                      ? _c(
                          "span",
                          [
                            _c("el-cascader", {
                              attrs: {
                                options: _vm.selectAddRiskChannl,
                                props: {
                                  value: "ID",
                                  label: "ID",
                                  lazy: true,
                                  lazyLoad: _vm.dynamicallyLoadingData,
                                },
                              },
                              model: {
                                value: _vm.editChannelRisk,
                                callback: function ($$v) {
                                  _vm.editChannelRisk = $$v
                                },
                                expression: "editChannelRisk",
                              },
                            }),
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  color: "blue",
                                  cursor: "pointer",
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.editChannelRiskShow = false
                                  },
                                },
                              },
                              [_vm._v("取消修改")]
                            ),
                          ],
                          1
                        )
                      : _c("span", [
                          _vm._v(" " + _vm._s(_vm.channelDetail.RiskKey) + " "),
                          _c(
                            "span",
                            {
                              staticStyle: { color: "blue", cursor: "pointer" },
                              on: {
                                click: function ($event) {
                                  _vm.editChannelRiskShow = true
                                },
                              },
                            },
                            [_vm._v("修改")]
                          ),
                        ]),
                  ])
                : _vm._e(),
            ],
            2
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.updateChannel },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: { title: "添加渠道", visible: _vm.addChannelDialogVisible },
          on: {
            "update:visible": function ($event) {
              _vm.addChannelDialogVisible = $event
            },
            close: _vm.closeAddChannelDialog,
          },
        },
        [
          _c(
            "el-form",
            { attrs: { inline: true, "label-position": "top" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "渠道" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "渠道" },
                      on: {
                        change: function ($event) {
                          return _vm.getDictObj(_vm.Sing)
                        },
                      },
                      model: {
                        value: _vm.Sing,
                        callback: function ($$v) {
                          _vm.Sing = $$v
                        },
                        expression: "Sing",
                      },
                    },
                    _vm._l(_vm.channelList, function (item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { value: item },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._l(_vm.channelDetails, function (item) {
                return _c(
                  "el-form-item",
                  { key: item.label, attrs: { label: item.label } },
                  [
                    _c("el-input", {
                      model: {
                        value: item.value,
                        callback: function ($$v) {
                          _vm.$set(item, "value", $$v)
                        },
                        expression: "item.value",
                      },
                    }),
                  ],
                  1
                )
              }),
              _vm.interfaceStr
                ? _c(
                    "el-form-item",
                    { attrs: { label: "Name" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.channelDetail.Name,
                          callback: function ($$v) {
                            _vm.$set(_vm.channelDetail, "Name", $$v)
                          },
                          expression: "channelDetail.Name",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.interfaceStr
                ? _c(
                    "el-form-item",
                    { attrs: { label: "通道类型" } },
                    [
                      _c(
                        "el-select",
                        {
                          on: {
                            change: function () {
                              _vm.channelDetail.Type = _vm.searchOption(
                                _vm.channelTypeList,
                                _vm.channelType
                              )
                            },
                          },
                          model: {
                            value: _vm.channelType,
                            callback: function ($$v) {
                              _vm.channelType = $$v
                            },
                            expression: "channelType",
                          },
                        },
                        _vm._l(_vm.channelTypeList, function (item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { value: item },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.interfaceStr
                ? _c(
                    "el-form-item",
                    { attrs: { label: "备注" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.channelDetail.ReMark,
                          callback: function ($$v) {
                            _vm.$set(_vm.channelDetail, "ReMark", $$v)
                          },
                          expression: "channelDetail.ReMark",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.interfaceStr
                ? _c(
                    "el-form-item",
                    { attrs: { label: "状态" } },
                    [
                      _c("el-switch", {
                        model: {
                          value: _vm.channelDetail.Status,
                          callback: function ($$v) {
                            _vm.$set(_vm.channelDetail, "Status", $$v)
                          },
                          expression: "channelDetail.Status",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.interfaceStr
                ? _c(
                    "el-form-item",
                    { attrs: { label: "风控开关" } },
                    [
                      _c("el-switch", {
                        model: {
                          value: _vm.channelDetail.RiskStatus,
                          callback: function ($$v) {
                            _vm.$set(_vm.channelDetail, "RiskStatus", $$v)
                          },
                          expression: "channelDetail.RiskStatus",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.channelDetail.RiskStatus
                ? _c(
                    "el-form-item",
                    { attrs: { label: "风控通道Key" } },
                    [
                      _c("el-cascader", {
                        attrs: {
                          options: _vm.selectAddRiskChannl,
                          props: {
                            value: "ID",
                            label: "ID",
                            lazy: true,
                            lazyLoad: _vm.dynamicallyLoadingData,
                          },
                          "change-on-select": true,
                        },
                        model: {
                          value: _vm.editChannelRisk,
                          callback: function ($$v) {
                            _vm.editChannelRisk = $$v
                          },
                          expression: "editChannelRisk",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            2
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.addChannel } },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }